export enum InvoiceDocTag {
  DUTY_MONTHLY_STATEMENT = 'DUTY_MONTHLY_STATEMENT',
  DUTY_DAILY_STATEMENT = 'DUTY_DAILY_STATEMENT',
  INLT_SUBSCRIPTION = 'INLT_SUBSCRIPTION',
  SERVICES_STATEMENT = 'SERVICES_STATEMENT',
  WORK_ORDER_GROUP_INVOICE = 'WORK_ORDER_GROUP_INVOICE',
}
